module.exports = "/assets/2beaf520984809307113b63bab88b955.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OY.png
// module id = 1697
// module chunks = 0